/*globals jQuery */
// Awards page JS
( function( $, undefined ) {
	'use strict';

	// Define global object.
	if ( typeof window.MSR !== 'object' ) {
		window.MSR = {};
	}

	window.MSR.awards = ( function() {
		var cache = {
			body: document.querySelector( '.awards' ),
			yearList: null,
			contentList: null,
			dropdown: null
		};

		var init = function() {
			var self = this,
				yearList;

			cache.yearList = yearList = cache.body.querySelectorAll( 'h3' );

			populateDropDown( yearList );

			hideAll();

			displayFirst();
		};

		var populateDropDown = function( yearList ) {
			var self = this,
				dropdown;

			cache.dropdown = dropdown = document.getElementById( 'year-selector' );

			Array.prototype.forEach.call( yearList, function( yearEl, index ) {
				var year = yearEl.innerHTML,
					option = document.createElement( 'option' );

				yearEl.id = yearEl.innerHTML;

				option.text = year;
				option.value     = year;

				// Default to first option in dropdown
				if ( index === 0 ) {
					option.selected = true;
				}

				dropdown.appendChild( option );
			} );

			dropdown.addEventListener( 'change', changeYear );
		};

		var hideAll = function() {
			var self = this,
				contentList,
				dropdown = cache.dropdown,
				selected = dropdown.options[ dropdown.selectedIndex ].value;

			cache.contentList = contentList = cache.body.querySelectorAll( 'ul' );

			Array.prototype.forEach.call( contentList, function( contentEl, index ) {
				contentEl.style.display = 'none';
			} );

			Array.prototype.forEach.call( cache.yearList, function( yearEl, index ) {
				yearEl.style.display = 'none';
			} );
		};

		/**
		 * Show all elements in the contentList
		 *
		 * @internal based off the hideAll method above
		 * @since 0.2.2
		 */
		var showAll = function() {
			var self = this,
				contentList;

			cache.contentList = contentList = cache.body.querySelectorAll( 'ul' );

			// Unhide all the <li> elements
			Array.prototype.forEach.call( contentList, function( contentEl, index ) {
				contentEl.style.display = 'block';
			} );

			// Unhide the year <h3> elements
			Array.prototype.forEach.call( cache.yearList, function( yearEl, index ) {
				yearEl.style.display = 'block';
			} );
		};

		var displayFirst = function() {
			// Display only first elements.
			cache.yearList[0].style.display    = 'block';
			cache.contentList[0].style.display = 'block';
		};

		var changeYear = function() {
			var self     = this,
				selected = self.options[ self.selectedIndex ].value,
				newYear;

			newYear = document.getElementById( selected );

			hideAll();

			if ( selected === 'all' ) {
				showAll();

			} else if ( newYear ) {
				newYear.style.display = 'block';
				newYear.nextElementSibling.style.display = 'block';
			}

			triggerBI( self, selected );
		};

		var triggerBI = function( el, option ) {
			window.MSR.wedecsBi.sendCustomEvent( el, {
				'ms.interactionType': 16,
				'ms.title': option
			} );
		};

		return {
			init: init,
			cache: cache
		};
	} )();

	$( function() {
		if ( window.MSR.awards.cache.body ) {
			window.MSR.awards.init();
		}
	} );
} )( jQuery );
